export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14660.ddf9d741.jpg";